/* eslint-disable */ 
export default {
    keycloak: {},
    loading: true,   
    dataHeader: {}
}
